import { useState, useEffect, useCallback } from 'react';

export type ThemeType = 'light' | 'dark' | 'night';

const STORAGE_KEY = 'sportlink-theme';
const DEFAULT_THEME: ThemeType = 'night';

export const getStoredTheme = (): ThemeType => {
  if (typeof window === 'undefined') return DEFAULT_THEME;
  return (localStorage.getItem(STORAGE_KEY) as ThemeType) || DEFAULT_THEME;
};

export const applyTheme = (theme: ThemeType) => {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.remove('light', 'dark', 'night');
  document.documentElement.classList.add(theme);
};

export const useTheme = () => {
  const [theme, setThemeState] = useState<ThemeType>(getStoredTheme);

  const setTheme = useCallback((newTheme: ThemeType) => {
    setThemeState(newTheme);
    localStorage.setItem(STORAGE_KEY, newTheme);
    applyTheme(newTheme);
  }, []);

  // Apply theme on mount
  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  return { theme, setTheme };
};

export default useTheme;
